<template>
    <v-card bordered flat>
      <v-card-title class="subtitle-2 text-uppercase">Layout Info</v-card-title>
      <v-divider></v-divider>
      <v-list dense class="body-2">
        <v-list-item
          v-for="(value, key) in details"
          :key="key"
        >
          <v-list-item-content>{{ key }}</v-list-item-content>
          <v-list-item-content class="align-end">{{ value }}</v-list-item-content>
        </v-list-item>
        <v-list-item>
            <v-list-item-content>
                <v-btn color="accent" class="mt-3"
                    block depressed
                    @click.prevent="onSubmit"
                >Change Settings</v-btn>
            </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'layout-info',
  computed: {
    ...mapGetters([
      'details',
    ]),
  },
  methods: {
    onSubmit() {
      this.$emit('submit');
    },
  },
};
</script>
